"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentDefinition = void 0;
const static_service_1 = require("@wix/static-service");
exports.EnvironmentDefinition = (0, static_service_1.defineStaticService)('viewer-core/viewer-service-environment');
//# sourceMappingURL=index.js.map